module.exports = __webpack_public_path__ + "media/images/responsive/fairs/event_detail/try_on_kimono-b15ccf4f8146df3ab5c276b81fdf65a7.jpg";